import {
    Avatar,
    AvatarBadge,
    Box,
    Flex,
    List,
    ListItem,
    Spacer,
    Stack,
    Text,
    Tooltip,
    Wrap,
    WrapItem
} from "@chakra-ui/react";
import React from "react";
import {
    Call,
    Participant,
    ParticipantRole,
    ParticipantStatus
} from "../../graphql";
import { formatDate, getFullName } from "../../utils";

// type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
// type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

type IParticipantsProps = {
  participants: Array<any>;
};

const Participants: React.FC<IParticipantsProps> = ({ participants }) => {
    return (
        <Stack direction="row" alignItems="flex-end">
            { participants.map((participant) => {
                const fullName = getFullName(participant.account);
                const status = participant.status as ParticipantStatus;

                const getStatus = (status) => {
                    if (status === ParticipantStatus.Answered) {
                        return "green.500";
                    } else if (status === ParticipantStatus.Expired) {
                        return "red.500";
                    } else if (status === ParticipantStatus.Left) {
                        return "green.100";
                    } else if (status === ParticipantStatus.Ringing) {
                        return "yellow.500";
                    }
                };

                return (
                    <Tooltip label={ fullName } aria-label={ fullName }>
                        <Avatar size="sm" name={ fullName }>
                            <AvatarBadge boxSize="1.25em" bg={ getStatus(status) } />
                        </Avatar>
                    </Tooltip>
                );
            }) }
        </Stack>
    );
};

export default Participants;
